import type { Promotion, PromotionDTO } from '@empathyco/playboard-core-domain'
import type { PromotionFactory } from './types'
import { BasePromotion } from '@empathyco/playboard-core-domain'

export const BasePromotionFactory: PromotionFactory = (dto?: PromotionDTO): Promotion => {
  return new BasePromotion(dto)
}
